<template>
  <div
    class="bottombtn wp flexpage"
    style="background: #fafafa; border: 0px; border-bottom: 1px slid #eee"
  >
    <div class="leftpage btnbox">
      <div class="back" @click="backPage">Back</div>
      <!-- slot for custom payment buttons (e.g. PayPal Checkout) -->
      <slot name="extra"></slot>
      <!-- Standard continue button — hidden when a custom payment button is passed via #extra -->
      <div
        v-if="!hideBtn"
        :class="['continue', notEmpty(btnTxt.cls) ? btnTxt.cls : '', btnTxt.status === 0 ? 'disabled' : '']"
        v-authenticated
        @click="toPage"
        ref="continue"
      >
        <img
          v-if="notEmpty(btnTxt.img)"
          :src="btnTxt.img"
          style="width: 100px; height: 100%; padding: 0 10px"
        />
        <span v-if="btnTxtParts" class="continue-text">
          <span v-if="btnTxtParts.label" class="continue-label">{{ btnTxtParts.label }}</span>
          <span class="continue-amounts">
            <span v-for="(amt, i) in btnTxtParts.amounts" :key="i" class="continue-amount">{{ amt }}</span>
          </span>
        </span>
        <span v-else style="width: 100%">{{ btnTxt.txt }}</span>
      </div>
    </div>
  </div>
  <bookingReview v-if="review" :roomlist="roomlist" :odata="odata"
      @reviewCloseWin="reviewCloseWin"></bookingReview>
  <alertDialog
    v-if="failMessage"
    @closeWin="closeFailDialog"
    :img="alertImg"
    :status="'success'"
    :title="alertTxt"
    :content="alertContent"
    :needConfirm="needConfirm"
    :cancelBtnTxt="cancelBtnTxt"
    :confirmBtnTxt="confirmBtnTxt"
    :confirmBtnSetting="confirmBtnSetting"
  />
  <!-- <div v-if="failMessage" class="error">
     <AlertDialog @closeWin="closeFailDialog()" 
        status="failure" :img="failimg" 
        title="Warning" :content="this.failMessage" /> 
    </div> -->
</template>
<script>
import { notEmpty } from '@/utils/tool.js'
import {  pagelog } from '@/utils/pagelog'
import Request from '@/services/Request'
import { useCartStore } from '../stores/CartStore'
import { useUserStore } from '../stores/UserStore'
import AlertDialog from '@/components/alertdialog.vue'
import { useOrderStore } from '@/stores/OrderStore'
import { useInsuranceStore } from '@/stores/InsuranceStore'
import { localDriver } from '@/utils/localDriver'
import bookingReview from '@/components/bookingReview.vue'
import { getRequiredMembershipTag, isMembershipInsufficient } from '@/utils/membership'

export default {
  components: { AlertDialog,bookingReview},
  props: ['step', 'steplist', 'btnTxt', 'rmkey', 'odkey', 'opkey', 'cartref', 'hideBtn','validateBeforeReview'],
  emits: ['refreshStep', 'alertEmail', 'refreshSumary'],
  data() {
    return {
      pagelog,
      notEmpty,
      failMessage: false,
      roomlist: [],
      odata: {},
      curOpid: 0,
      needConfirm: true,
      cancelBtnTxt: 'Refresh Page',
      confirmBtnTxt: 'Back to Homepage',
      alertContent: 'Oops!We encountered an issue processing your request. Please try again later.',
      alertTxt: '',
      alertImg: 'date_search.png',
      confirmBtnSetting: { bor: '1px solid #D5D5D5', bg: '#FFFFFF', color: '#000000' },
      token: '',
      permstep: 1,
      review:false,
      travelerValidationFailed: false,
      duplicateValidationFailed: false,
    }
  },
  mounted() {
    this.token = this.orderStore.token
    //alert('step'+this.step+'---'+this.token)
    // console.log('----cartref---', this.token)
    const banner = document.querySelector('#zpcookie-banner')
    if (null != banner) {
      banner.style.display = 'none'
    }
  },
  setup() {
    const cart = useCartStore()
    const orderStore = useOrderStore()
    const insuranceStore = useInsuranceStore()
    const userStore = useUserStore()
    return {
      cart: cart,
      orderStore,
      insuranceStore,
      userStore,
    }
  },
  watch: {
    // btnFooterIdx:{
    //     handler(newValue, oldValue) {
    //         if(newValue>0)
    //         {
    //             this.$nextTick(() => {
    //                 this.$refs.continue.click();
    //             });
    //         }
    //     },
    //     deep: true
    // },
  },
  expose: ['toPage'],
  computed: {
    // Dual-currency text "Today You Pay A$x,\nUS$y" -> { label: 'Today You Pay', amounts: ['A$x', 'US$y'] }
    btnTxtParts() {
      const txt = this.btnTxt?.txt
      if (typeof txt !== 'string' || !txt.includes('\n')) return null
      const lines = txt.split('\n').map((s) => s.trim().replace(/,$/, ''))
      const first = lines[0]
      const idx = first.lastIndexOf(' ')
      const label = idx > 0 ? first.slice(0, idx) : ''
      lines[0] = idx > 0 ? first.slice(idx + 1) : first
      return { label, amounts: lines }
    },
  },
  methods: {
    async reviewCloseWin(param){
       this.review = false;
       if(1==param.type){
          await this.addCart();
       }
       else if(2==param.type){
          await this.backPage();
       }
    },
    async closeFailDialog(param) {
      this.failMessage = false
      if (this.travelerValidationFailed) {
        this.travelerValidationFailed = false
        this.$emit('refreshStep', { cv: 1 })
        this.$router.push('/booking?tk=' + this.orderStore.token)
        return
      }
      if (this.duplicateValidationFailed) {
        this.duplicateValidationFailed = false
        this.needConfirm = true
        return
      }
      if (notEmpty(param.confirm)) {
        this.odata = await localDriver.getItem(this.odkey)
        window.location = '/details?id=' + this.odata.product_id
      } else if (notEmpty(param.close)) {
        return
      } else {
        location.reload()
      }
    },
    async requiredOption() {
      //console.log('----------group select-----0----', this.odata)
      let res = true
      this.odata = await localDriver.getItem(this.odkey)
      this.curPopid = 0
      if ('oriOptions' in this.odata) {
        //console.log('---------oriOptions-----0----')
        for (let i in this.odata.oriOptions) {
          this.curPopid = this.odata.oriOptions[i].product_option_id
          if (this.odata.oriOptions[i].option_id != 55 && this.odata.oriOptions[i].required > 0) {
            if (notEmpty(this.odata.options)) {
              let garr = [] //gid>0, 产生必选分组的所有product_option_value_id
              for (let j in this.odata.oriOptions[i].product_option_value) {
                let pov = this.odata.oriOptions[i].product_option_value[j]
                if (pov.gid > 0) {
                  garr.push(pov.product_option_value_id)
                }
              }
              //分组必选存在，且分组必选已选过，res = true, 否则 false
              if (garr.length > 0) {
                res = false
                for (let k in garr) {
                  if (garr[k] in this.odata.options && this.odata.options[garr[k]].length > 0) {
                    //console.log('----------group select---------', [garr, this.odata.options])
                    res = true
                    break
                  }
                }
              }
            } else {
              //必选一个未选，而必选（gid > 0）又存在  ： 此情形不存在，因为在生成页面option选择时，代码已自动加上勾选
              for (let j in this.odata.oriOptions[i].product_option_value) {
                let pov = this.odata.oriOptions[i].product_option_value[j]
                if (pov.gid > 0) {
                  res = false
                  break
                }
              }
            }
          }
          if (!res) {
            this.$emit('refreshStep', { validation: { popid: this.curPopid } })
            break
          }
        }
      }
      return res
    },
    async backPage() {
      this.odata = await localDriver.getItem(this.odkey)
      if(!this.odata) return false      
      if ( 1 == this.step) {
        if ('flightOffer' in this.odata) {
          //select flight reset
          this.$emit('refreshSumary', {
            item: { id: this.odata.flightOffer.id, responseOfferId: this.odata.flightOffer.rid }
          })
        } else {
          const productTokenKey = 'p_token_key_' + this.orderStore.token
          const pkey = await localDriver.getItem(productTokenKey)
          const backtoken =
            await localDriver.getItem('cmkey_' + this.orderStore.token) ==
            await localDriver.getItem('customer_id')
              ? 'tk=' + this.orderStore.token
              : ''
          if (null != pkey && 'null' != pkey) {
            window.location = `/${pkey}?` + backtoken
          } else {
            let curUrl = '/details?id=' + this.odata.product_id
            if(notEmpty(this.odata.mystery_order_id)){
              curUrl +='&mystery_order_id='+this.odata.mystery_order_id
            }
            curUrl += (backtoken ? '&' + backtoken : '')
            window.location =curUrl              
          }
        }
      } else if (2 == this.step) {
        if ('flightOffer' in this.odata) {
          this.$router.push('/flight?tk=' + this.orderStore.token)
        } else {
          const productTokenKey = 'p_token_key_' + this.orderStore.token
          const pkey = await localDriver.getItem(productTokenKey)
          const backtoken =
            await localDriver.getItem('cmkey_' + this.orderStore.token) ==
            await localDriver.getItem('customer_id')
              ? 'tk=' + this.orderStore.token
              : ''
          if (null != pkey && 'null' != pkey) {
            window.location = `/${pkey}?` + backtoken
          } else {
            let curUrl = '/details?id=' + this.odata.product_id
            if(notEmpty(this.odata.mystery_order_id)){
              curUrl +='&mystery_order_id='+this.odata.mystery_order_id
            }
            curUrl += (backtoken ? '&' + backtoken : '')
            window.location =curUrl 
          }
        }
      } else if (3 == this.step) {
        window.location.href = '/booking?tk=' + this.orderStore.token
      } else if (this.step > 3) {
        window.location.href = '/booking/insurance?tk=' + this.orderStore.token
      }
    },
    async toPage() {
      this.review = false;
      await this.userStore.checkState()
      let curUser = this.userStore.user

      // Load order data first to check if product requires membership
      this.roomlist = await localDriver.getItem(this.rmkey)
      this.odata = await localDriver.getItem(this.odkey)
      if(!this.odata) return false

      // Check if product requires membership level
      let tripMemberNeed = getRequiredMembershipTag(this.odata?.product_info?.tag)?.membershiptype_id ?? 0

      // Only redirect if product requires membership AND user membership level is insufficient
      if(isMembershipInsufficient(curUser?.memberType, tripMemberNeed)){
         // Redirect to membership page
          window.location.href = '/membership'
          return
      } 
      if (1 == this.step) {
        if (notEmpty(this.odata.flightOffer)) {
          //this.$emit('refreshStep',{step:parseInt(this.step)+1});
          this.pagelog(new Request(), 'booking')
          this.$router.push(
            '/' + this.steplist[parseInt(this.step)].path + '?tk=' + this.orderStore.token
          )
        } else {
          this.$emit('refreshStep', { dialog: true })
        }
      } else if (2 == this.step) {
        if (!this.btnTxt.status) {
          this.$emit('refreshStep', { cv: 1 })
        } else if (!(await this.ensureRoomTravelersReady(this.roomlist))) {
          return
        } else if (!(await this.precheckDuplicateBeforeInsurance())) {
          return
        } else if (await this.requiredOption()) {
          this.$emit('refreshStep', { step: parseInt(this.step) + 1 })
          this.pagelog(new Request(), 'insurance') ///, [this.roomlist, this.odata]);
          this.$router.push('/booking/insurance?tk=' + this.orderStore.token)
        }
      } else if (this.step == 3) {                
        if (this.insuranceStore.skip || await this.insuranceStore.validateInsurancePlan()) {
          if (!(await this.ensureRoomTravelersReady(this.roomlist))) {
            return
          }
          this.review = true;
          //await this.addCart()
        } else {
          let alertMsg = (!this.insuranceStore.skip)?'InsuranceNoSelected':'insuranceValidation'
          this.pagelog(new Request(),alertMsg) //, [this.roomlist, this.odata]);
          this.$emit('refreshStep', {})
        }
      } else if (this.step > 3) {        
        if (this.permstep == 1 && this.btnTxt.txt != 'Process...') {
          this.permstep = 0
          this.pagelog(new Request(), 'clickPayout')
          this.$emit('refreshStep', { step: 99 })
          setTimeout(() => {
            this.permstep = 1;            
          }, 3000)
        }
      }      
    },
    cartOpt(stdOptions) {
      var res = []
      if (notEmpty(stdOptions)) {
        for (var i in stdOptions) {
          if (notEmpty(stdOptions[i])) {
            res[i] = stdOptions[i]
          }
        }
      }
      return res
    },
    roomHasValidTravelers(room) {
      const adults = parseInt(room?.Adults ?? room?.adult ?? 0)
      const children = parseInt(room?.Child ?? room?.child ?? 0)
      const adultList = Array.isArray(room?.Adultslist) ? room.Adultslist : []
      const childList = Array.isArray(room?.Childlist) ? room.Childlist : []
      const hasTravelerFields = (traveler) => {
        if (!traveler || typeof traveler !== 'object') {
          return false
        }
        const firstname = String(traveler.firstname ?? '').trim()
        const lastname = String(traveler.lastname ?? '').trim()
        return firstname !== '' && lastname !== ''
      }

      if (adultList.length !== adults || childList.length !== children) {
        return false
      }

      return adultList.every(hasTravelerFields) && childList.every(hasTravelerFields)
    },
    roomTravelerValidation(room) {
      const adults = parseInt(room?.Adults ?? room?.adult ?? 0)
      const children = parseInt(room?.Child ?? room?.child ?? 0)
      const adultList = Array.isArray(room?.Adultslist) ? room.Adultslist : []
      const childList = Array.isArray(room?.Childlist) ? room.Childlist : []
      const missingNames = [...adultList, ...childList].filter(
        (traveler) =>
          !traveler ||
          !String(traveler.firstname ?? '').trim() ||
          !String(traveler.lastname ?? '').trim()
      ).length
      return { adults, children, adult_list: adultList.length, child_list: childList.length, missing_names: missingNames }
    },
    collectTravelersForDuplicateCheck(roomlist = []) {
      const travelers = []
      if (!Array.isArray(roomlist)) {
        return travelers
      }

      const pushTraveler = (person) => {
        const firstname = String(person?.firstname ?? '').trim()
        const lastname = String(person?.lastname ?? '').trim()
        const middlename = String(person?.middlename ?? '').trim()
        const passport = String(person?.PassportNo ?? person?.passport ?? '').trim()
        if (firstname && lastname) {
          travelers.push({
            firstname,
            middlename,
            lastname,
            passport
          })
        }
      }

      for (const room of roomlist) {
        const adults = Array.isArray(room?.Adultslist) ? room.Adultslist : []
        const children = Array.isArray(room?.Childlist) ? room.Childlist : []
        adults.forEach(pushTraveler)
        children.forEach(pushTraveler)
      }

      return travelers
    },
    openDuplicateBookingAlert(message = '') {
      this.duplicateValidationFailed = true
      this.needConfirm = false
      this.alertTxt = 'Caution'
      this.alertContent =
        message ||
        'Please update traveler information and ensure there are no duplicate travelers for the same tour and departure date.'
      this.failMessage = true
    },
    async precheckDuplicateBeforeInsurance() {
      const travelers = this.collectTravelersForDuplicateCheck(this.roomlist)
      if (!travelers.length) {
        return true
      }

      const customerId = await localDriver.getItem('cmkey_' + this.orderStore.token)
      const payload = {
        customer_id: customerId || 0,
        product_id: this.odata?.product_id ?? 0,
        depart_date: this.odata?.depart_date ?? '',
        travelers,
        options: this.cartOpt(this.odata?.options)
      }

      return await new Promise((resolve) => {
        new Request().webPost(
          payload,
          (res) => {
            const lowerMsg = String(res?.msg ?? '').toLowerCase()
            const isDuplicate =
              res?.success === false &&
              (res?.duplicate === true ||
                lowerMsg.includes('duplicate traveler') ||
                lowerMsg.includes('duplicate booking') ||
                lowerMsg.includes('same tour') ||
                lowerMsg.includes('departure date'))

            if (isDuplicate) {
              this.pagelog(new Request(), 'duplicate_precheck_block', {
                product_id: payload.product_id,
                depart_date: payload.depart_date
              })
              this.openDuplicateBookingAlert(res?.msg)
              resolve(false)
              return
            }
            resolve(true)
          },
          'checkout/cart/duplicateCheck',
          () => {
            this.openDuplicateBookingAlert(
              'Unable to verify duplicate booking right now. Please try again.'
            )
            resolve(false)
          }
        )
      })
    },
    async ensureRoomTravelersReady(roomlist = null) {
      const currentRoomlist = roomlist || (await localDriver.getItem(this.rmkey)) || []
      const ready =
        Array.isArray(currentRoomlist) &&
        currentRoomlist.length > 0 &&
        currentRoomlist.every((room) => this.roomHasValidTravelers(room))

      if (!ready) {
        this.pagelog(new Request(), 'cart_missing_traveler', {
          room_count: Array.isArray(currentRoomlist) ? currentRoomlist.length : 0,
          summary: Array.isArray(currentRoomlist)
            ? currentRoomlist.map((room, index) => ({ room_index: index, ...this.roomTravelerValidation(room) }))
            : []
        })
        this.travelerValidationFailed = true
        this.alertTxt = 'Traveler Information Required'
        this.alertContent =
          'Please complete traveler information for every room before continuing to payment.'
        this.failMessage = true
      }

      return ready
    },
    async addCart() {
        var room = []
        var contact = {}
        var note = ''

        this.roomlist = await localDriver.getItem(this.rmkey)
        this.odata = await localDriver.getItem(this.odkey)

        if (!(await this.ensureRoomTravelersReady(this.roomlist))) {
          return
        }

        if (notEmpty(this.roomlist)) {
          for (var i in this.roomlist) {
            var traveler = []
            var person = []

            //console.log('----------------cart----', this.roomlist)
            if (notEmpty(this.roomlist[i].Adultslist)) {
              for (let j in this.roomlist[i].Adultslist) {
                person = this.roomlist[i].Adultslist[j]
                traveler.push({
                  lastname: person.lastname,
                  middlename: person.middlename,
                  firstname: person.firstname,
                  traveler_uid: person.travelerUid || person.traveler_uid || '',
                  email: person.Email,
                  phone: person.Phone,
                  phoneZone: person.phoneZone,
                  // gender:(person.Gender=='Female' || person.Gender=='female')?2:1,
                  gender: person.Gender,
                  birthday: person.Birthday,
                  later: this.odata.passportLater,
                  nationality: person.Nationality,
                  passport: person.PassportNo,
                  passport_exp: person.Expireddate,
                  issueplace: person.issueplace,
                  // country_id:person.Province?person.Nationality:0,   //person.Country,
                  country_id: person.Nationality,
                  /*    zone_id: person.province, */
                  zone_id: person.resident_of
                })
                contact = {
                  mainconcator:
                    this.roomlist[0].Adultslist[0].lastname +
                    ' ' +
                    this.roomlist[0].Adultslist[0].middlename +
                    ' ' +
                    this.roomlist[0].Adultslist[0].firstname,
                  rmail: this.roomlist[i].Adultslist[0].Email,
                  phone: this.roomlist[i].Adultslist[0].Phone
                }
                note = '' //this.roomlist[i].Adultslist[j].request;
                // if('Email' in this.roomlist[i].Adultslist[j])
                // {
                //     note = this.roomlist[i].Adultslist[j].request;

                // }
              }
            }
            if (notEmpty(this.roomlist[i].Childlist)) {
              for (let j in this.roomlist[i].Childlist) {
                person = this.roomlist[i].Childlist[j]
                traveler.push({
                  lastname: person.lastname,
                  middlename: person.middlename,
                  firstname: person.firstname,
                  traveler_uid: person.travelerUid || person.traveler_uid || '',
                  email: person.Email,
                  phone: person.Phone,
                  phoneZone: person.phoneZone,
                  /// pAreaCode: person.Phone,
                  //gender:(person.Gender=='Female' || person.Gender=='female')?2:1,
                  gender: person.Gender,
                  birthday: person.Birthday,
                  later: this.odata.passportLater,
                  nationality: person.Nationality,
                  passport: person.PassportNo,
                  passport_exp: person.Expireddate,
                  issueplace: person.issueplace,
                  country_id: person.Nationality,
                  //  country_id:person.Country,
                  /*   zone_id: person.Province, */
                  zone_id: person.resident_of
                })
              }
            }
            //console.log('post cart', [this.roomlist[i], traveler]);
            room.push({
              adult: this.roomlist[i].Adults,
              child: this.roomlist[i].Child,
              bedtype: this.roomlist[i].selectedbedroom,
              traveler: traveler
            })
          }
        }
        var pickup = {
          arrive: { date: '', flight: '', airport: '', time: ['-1', '-1'] },
          depart: { date: '', flight: '', airport: '', time: ['-1', '-1'] }
        }
        if (this.odata.pickup && 1 == this.odata.pickup.type) {
          for (var pp in this.odata.pickup.info) {
            var curinfo = this.odata.pickup.info[pp]
            pickup[pp] = {
              ...{},
              date: curinfo.date,
              flight: curinfo.no,
              airport: curinfo.airport,
              time: [curinfo.hour, curinfo.minute]
            }
          }
        }
        //console.log('---post to shopping cart---',room);
        const mysteryOrderId = this.odata.mystery_order_id || 0

        let codata = { ...this.odata }
        delete codata.oriOptions

        //pageCurrency
        var cartInterfaceData = {
          product_id: this.odata.product_id,
          mystery_order_id: mysteryOrderId,
          depart_date: this.odata.depart_date,
          depart_city: (this.odata.isFlight>0 && this.odata.selectedCity) ? this.odata.selectedCity.area_id : 261,
          room: room,
          contact: contact,
          note: note,
          pickup: {
            type: this.odata.pickup ? this.odata.pickup.type : 0,
            arrive: pickup.arrive,
            depart: pickup.depart
          },
          options: this.cartOpt(this.odata.options),
          insuranceprice: this.insuranceStore.unPayDisplay??this.insuranceStore.unPay,
          cartback: {
            customer_id: await localDriver.getItem('cmkey_' + this.token),
            token: this.token,
            roomlist: this.roomlist,
            order_data: JSON.stringify(codata),
            orderPrices: await localDriver.getItem(this.opkey),
          } //if set this, you can get this by : checkout/cart/getCartBack for restoring your order process,this object value depend on  your page need
        }
        /*     console.log('---post to shopping cart---',[this.odata,cartInterfaceData]);
                    return;  */
        new Request().webPost(
          cartInterfaceData,
          (res) => {
            if (res.success == 1) {
              const nextCount = Number(
                res?.cart?.count ?? res?.quantities ?? this.cart?.getCount?.() ?? 0
              )
              if (Number.isFinite(nextCount) && nextCount >= 0) {
                this.cart.setCount(nextCount)
              }
              this.$emit('refreshStep', { step: parseInt(this.step) + 1 })
              this.pagelog(new Request(), 'payment') ///, this.odata);
              this.$router.push('/payment?tk=' + this.orderStore.token)
            } else if (res.success == 0) {
              this.pagelog(new Request(), 'cart_error', res)
              //this.cart.setCount(parseInt(this.cart.getCount()*1.0));
              //    alert(res.msg);
              if (typeof res?.msg === 'string' && res.msg.trim() !== '') {
                this.alertTxt = 'Warning'
                this.alertContent = res.msg
              } else {
                this.alertTxt = ''
                this.alertContent =
                  'Oops!We encountered an issue processing your request. Please try again later.'
              }
              this.failMessage = true //res.msg;
              //return false;
            }
          },
          'checkout/cart/save',
          (err) => {
            console.log('----Error----', err)
          }
        )
    }
  }
}
</script>

<!-- 公共区域 -->
<style scoped>
.leftpage {
  width: 68.6%;
}

.bottombtn {
  border-top: 1px solid #eaeaea;
  background: #fff;
  padding-top: 0;
}
.bottombtn .btnbox {
  padding: 0.5rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  line-height: 4.8rem;

  font-size: 1.6rem;
  font-weight: 700;
}

.bottombtn .back {
  border-radius: 0.8rem;
  background: #fff;
  width: 12rem;
  color: #333;
  cursor: pointer;
  width: 100px;
  font-weight: 700;
  border: 1px solid #eee;
  width: 13rem;
  margin-right: 1.5rem;
}

.bottombtn .continue {
  cursor: pointer;
  background: #00f1bd;
  border-radius: 0.8rem;
  width: calc(100% - 13.6rem);
  color: #000;
  width: auto;
  font-weight: 700;
  display: flex;
  align-items: center;
}
.bottombtn .pp_pro {
  background: #ffc439;
}
.bottombtn .back {
  font-size: 1.6rem;
}

.bottombtn .continue {
  font-size: 1.6rem;
  padding: 0px 10px;
  min-width: 11rem;
}

.bottombtn .continue.disabled {
  /* greyed-out visual when btnTxt.status === 0 (e.g. traveler info incomplete) */
  opacity: 0.45;
  cursor: not-allowed;
}

.bottombtn .continue span {
  white-space: nowrap;
}

.bottombtn .continue .continue-text {
  width: 100%;
}

.bottombtn .continue .continue-label {
  margin-right: 0.4em;
}

.bottombtn .continue .continue-amount + .continue-amount::before {
  content: ', ';
}

/* 移动端  */
@media screen and (max-width: 750px) {
  .bottombtn .btnbox {
    line-height: 4.8rem;
    font-size: 1.6rem;
    min-height: 5.6rem;
    justify-content: center;
    gap: 1.2rem;
    padding-left: 1.6rem;
    padding-right: 1.6rem;
  }
  .bottombtn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: var(--mobile-nav-height, 0px);
    z-index: 1200;
    box-shadow: 0 -0.4rem 1.2rem rgba(0, 0, 0, 0.08);
    padding-bottom: max(0.6rem, env(safe-area-inset-bottom));
  }

  .leftpage,
  .rightpage {
    width: 100%;
    margin-top: 0;
  }

  .bottombtn .back {
    font-size: 1.3rem;
    width: 8.8rem;
    margin-right: 0.8rem;
  }

  .bottombtn .continue {
    font-size: 1.2rem;
    max-width: 22rem;
    width: auto;
    flex: 0 1 auto;
    justify-content: center;
    padding: 0 0.6rem;
    min-height: 4.8rem;
  }

  .bottombtn .continue span {
    font-size: 1.2rem;
    white-space: nowrap;
  }

  /* dual-currency: label on the left, amounts stacked on the right */
  .bottombtn .continue .continue-text {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.4;
    padding: 0.4rem 0;
  }

  .bottombtn .continue .continue-amounts {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .bottombtn .continue .continue-amount + .continue-amount::before {
    content: none;
  }
}
</style>
